module.exports = __webpack_public_path__ + "img/unionpay.edf051b1.svg";